// reach_ui/src/components/VastGPT/RelevantInfo.js
import React from 'react'
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const RelevantInfo = ({ relevantInfo }) => {
  if (!relevantInfo || relevantInfo.length === 0) {
    return null
  }

  return (
    <ExpansionPanel>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Relevant Information</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <div>
          {relevantInfo.map((info, index) => (
            <div key={index}>
              <Typography variant="subtitle1">{info.title}</Typography>
              <Typography variant="body2">{info.content}</Typography>
            </div>
          ))}
        </div>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default RelevantInfo
